import dayjs from 'dayjs';
import cloneDeep from 'lodash.clonedeep';
import { mergeAndRemoveDuplicates } from './merge';

// The first segment is always included regardless of `activeSegmentsOnly` and `activeOnDate`,
export function policyDetailsFromSegments(
  policy: Record<string, any>,
  { activeSegmentsOnly = false, activeOnDate = '' } = {}
) {
  const policyDetails = cloneDeep(policy.segments[0]);
  for (let i = 1; i < policy.segments.length; i += 1) {
    if (activeSegmentsOnly && dayjs(policy.segments[i].startDate).isAfter(dayjs())) {
      // Ignore any segments that start in the future if `activeSegmentsOnly` is true
      continue;
    }

    if (
      activeOnDate &&
      (dayjs(policy.segments[i].startDate).isAfter(dayjs(activeOnDate)) ||
        dayjs(policy.segments[i].startDate).isSame(dayjs(activeOnDate)))
    ) {
      // for claims only show policy segments that are active on date of loss
      continue;
    }

    if (dayjs(policy.segments[i].startDate).isAfter(policy.endDate)) {
      // ignore any renewal segments
      continue;
    }
    mergeAndRemoveDuplicates(policyDetails, policy.segments[i]);
  }
  if (policyDetails.premium) {
    // we don't want the segment details premium to override policy.premium
    // and we copy the elements here to the root of policy
    delete policyDetails.premium;
  }
  return policyDetails;
}
